type Currency = { code: string; symbol: string, en: string; es: string; fr: string };

export const currencies: Currency[] = [
  { code: "CHF", symbol: "CHF", en: "Swiss Franc", es: "Franco Suizo", fr: "Franc Suisse" },
  { code: "EUR", symbol: "€", en: "Euro", es: "Euro", fr: "Euro" },
  { code: "USD", symbol: "$", en: "US Dollar", es: "Dólar Estadounidense", fr: "Dollar Américain" },
  { code: "PEN", symbol: "S/.", en: "Peruvian Sol", es: "Sol Peruano", fr: "Sol Péruvien" }
]
